import { render, staticRenderFns } from "./publishGoodThingsList.vue?vue&type=template&id=399bb8ee&scoped=true"
import script from "./publishGoodThingsList.vue?vue&type=script&lang=js"
export * from "./publishGoodThingsList.vue?vue&type=script&lang=js"
import style0 from "./publishGoodThingsList.vue?vue&type=style&index=0&id=399bb8ee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "399bb8ee",
  null
  
)

export default component.exports